var _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: "40px",
    height: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dbf2ff",
    d: "M3.5 38.5L3.5 13.286 19.998 3.58 36.5 13.286 36.5 38.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7496c4",
    d: "M19.998,4.16L36,13.572V38H4V13.572L19.998,4.16 M19.998,3L3,13v26h34V13L19.998,3L19.998,3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5ddf5",
    d: "M4 34H36V38H4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M19.998 4.645L1.5 15.955 1.5 12.896 19.998 1.586 38.5 12.896 38.5 15.955z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M19.998,2.172L38,13.176v1.887L20.519,4.378l-0.522-0.319l-0.522,0.319L2,15.063v-1.887 L19.998,2.172 M19.998,1L1,12.615v4.231L19.998,5.231L39,16.846v-4.231L19.998,1L19.998,1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc49c",
    d: "M14.5 21.5H25.5V38.5H14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M25,22v16H15V22H25 M26,21H14v18h12V21L26,21z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a16a4a",
    d: "M23 30A1 1 0 1 0 23 32A1 1 0 1 0 23 30Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.32509700f557fb1b209877774629eeeb.svg";
export { ForwardRef as ReactComponent };